
<template>
  <div
    class="ecard"
    itemscope
    itemtype="https://schema.org/RealEstateListing"
  >
    <div class="ecard__top">
      <EstateCardSlider
        :key="random"
        :random="random"
        :image-list="card.images"
        class="ecard__slider"
        @click="estateShow"
        itemprop="image"
      />
    </div>
    <div class="ecard__bottom">
      <div class="ecard__info">
        <p class="ecard__title" @click="estateShow" itemprop="name">
          {{ card.title }}
        </p>

        <div
          class="ecard__address"
          itemprop="address"
          itemscope
          itemtype="https://schema.org/PostalAddress"
        >
          <p>
            <span itemprop="addressRegion">{{ card.location.region }}</span>,
            <span itemprop="streetAddress">{{ card.location.address }}</span>
          </p>

          <div class="ecard__subway-list">
            <SubwayList
              v-show="card.location.metro"
              :subway-list="card.location.metro"
            />
          </div>
        </div>

        <div class="ecard__row">
          <div class="ecard__description" itemprop="description">
            <p @click="estateShow" class="ecard__more">Читать далее</p>
          </div>

          <div
            itemprop="offers"
            itemscope
            itemtype="https://schema.org/Offer"
            class="ecard__price-wrapper"
          >
            <meta itemprop="priceCurrency" :content="card.currency || 'RUB'" />
            <meta itemprop="price" :content="card.price" />
            <span class="ecard__price" v-if="card.price" v-currency="card.price" />
          </div>
        </div>

        <div class="ecard__actions">
          <div class="ecard__icon-buttons">
            <div v-if="card.location.latitude" class="estate-card__hover-buttons">
              <ButtonLocation @click="openMap = true" />
              <teleport v-if="openMap" to="body">
                <AppModal v-model="openMap">
                  <ModalMap
                    :coords="[+card.location.latitude, +card.location.longitude]"
                    :title="card.title"
                  />
                </AppModal>
              </teleport>
            </div>
            <ButtonLike
              v-if="card.is_zhk !== 1 && !allCardsAreSmall"
              :alias="card.alias"
              :is-liked="isLiked"
              @like-card="handleLike(card.alias)"
            />
          </div>

          <EstateActions
            v-if="!map"
            class="ecard__button"
            :button-exchange="card.type === 'Продажа' ? true : false"
            one-btn
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppModal from '@/components/ui/AppModal.vue';
import ModalMap from './ModalMap.vue';
import ButtonLike from './ui/ButtonLike.vue';
import ButtonLocation from './ui/ButtonLocation.vue';
import EstateCardSlider from './EstateCardSlider.vue';
import EstateActions from './EstateActions.vue';
import SubwayList from './ui/SubwayList.vue';
import router from '@/router';
import { onMounted, ref, computed } from 'vue';
import { useFavoritesStore } from "@/store/store.js";

const props = defineProps({
    card: Object,
})
const store = useFavoritesStore();

const openMap = ref(false)
const setRoute = (id) => {
    let name;
    switch (true) {
        case id == 1 || id == 3 || id == 4 || id == 5:
            name = "Детальная загородной";
            break;
        case id == 7 || id == 8:
            name = "Детальная вторички";
            break;
        case id == 12:
            name = "Детальная коммерческой";
            break;
        case id == 99:
            name = 'Страница помещения заграничной недвижимости';
            break;
        default:
            break;
    }
    return name;
}

const cardRoute = computed(() => {
    return {
        name: setRoute(props.card.category.id),
        params: {
            alias: props.card.alias,
        },
    }
})

const estateShow = () => {
    router.push(cardRoute.value);
}

const handleLike = (alias) => {
    store.addFavorites(alias);
}

onMounted(() => {
    // console.log(props.card)
})
</script>

<style lang="scss" scoped>
.ecard {
    height: 100%;
    display: flex;
    flex-direction: column;

    &__top {
        // flex: 0 1 494px;
        
    }

    &__slider {
        // aspect-ratio: 550/494;
        height: 100%;
        width: 100%;
    }

    &__bottom {
        flex: 1;
        min-height: 336px;
        background-color: $color_dark-20;
        border-bottom-right-radius: 30px;
        padding: 16px;

        @include phone {
            border-bottom-right-radius: 30px;
        }
    }

    &__title {
        font-size: 28px;
        line-height: 32px;
    }

    &__address {
        font-size: 14px;
        line-height: 18px;
    }

    &__subway-list {
        height: 19px;
    }

    &__info {
        display: flex;
        flex-direction: column;
        gap: 32px;
        height: 100%;
    }

    &__art {
        font-size: 14px;
        line-height: 18px;
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    &__price {
        font-size: 28px;
        line-height: 120%;
        color: $color_orange-50
    }

    &__row {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    &__more {
        font-size: 14px;
        line-height: 18px;
        color: $color_orange-50;
        text-transform: uppercase;
    }

    &__actions {
        display: flex;
        justify-content: space-between;
        // flex-direction: column;
        gap: 10px;
        margin-top: auto;
    }

    &__icon-buttons {
        display: flex;
        align-items: center;
        gap: 10px;

        &>* {
            flex-shrink: 0;
        }
    }

    &__buttons {
        display: flex;
        align-items: center;
        gap: 10px;
    }
}
</style>